import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { pl } from 'date-fns/locale';
import { Provider } from 'react-redux';
import Router from './router';
import configureStore from './store';
import './styles/main.css';

const theme = createTheme({
  palette: { primary: { main: '#742ECC' }, secondary: { main: '#2E8BCC' } },
  typography: { fontFamily: "'Roboto', sans-serif" }
});

// Nothing runs at import time: a spec can import this module without mounting the app.
export function mount(container: HTMLElement) {
  const store = configureStore();
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pl}>
            <CssBaseline />
            <Router />
          </LocalizationProvider>
        </ThemeProvider>
      </Provider>
    </StrictMode>
  );
  return root;
}
